// Copyright (c) 2021 Greener Power Solutions.
// This file is part of Greener Power Solutions' software,
// and may not be altered, copied, redistributed, or sold
// without specific permission.

const brand = {
  main: '#5A946E',
  'forest-green': '#123F22',
  'lime-green': '#44FF00',
};

const state = {
  'state-error': '#F74D4D',
  'state-error-dark': '#E12525',
  'state-warning': '#FFB421',
  'state-warning-dark': '#EFA309',
  'state-success': '#05B246',
};

export const grey = {
  50: '#F7F7F7',
  100: '#F4F4F4',
  200: '#E9E9E9',
  300: '#D4D4D3',
  400: '#BEBEBE',
  500: '#A9A8A8',
  600: '#939392',
  700: '#7E7D7C',
  800: '#686767',
  900: '#535251',
  1000: '#3C3C3B',
};

export const blueprint = {
  primary: '#078FD8',
  background: '#D0E8F5',
  'gradient-primary': '#6ABF8B',
  'gradient-light': '#E9FFF2',
};

export const badge = {
  'moss-green': '#A4AF21',
  'dark-orange': state['state-warning-dark'],
  'mint-green': brand.main,
  'hydro-blue': '#13AFA5',
  'dark-green': '#1F672C',
  'fossil-grey': grey[900],
};

export default {
  ...state,
  brand,
  badge,
  grey,
  blueprint,
};
